module.exports = __webpack_public_path__ + "img/logo_1880_black.1c4005c.webp";